module.exports = {"helmetTitle":"Veloe - Editar Dados institucionais","title":"Dados institucionais","subtitle":"Aqui você pode editar as informações da sua empresa para deixar a gente sempre atualizado. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Ops!","descriptionModalError":"Verifique todas as informações e tente novamente."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditCompanyData/data.json
// module id = 1723
// module chunks = 0